import { render, staticRenderFns } from "./StopPL_List.vue?vue&type=template&id=5af328e9"
import script from "./StopPL_List.vue?vue&type=script&lang=js"
export * from "./StopPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports